import { render, staticRenderFns } from "./kf-header.vue?vue&type=template&id=5df1101a"
import script from "./kf-header.vue?vue&type=script&lang=js"
export * from "./kf-header.vue?vue&type=script&lang=js"
import style0 from "./kf-header.vue?vue&type=style&index=0&id=5df1101a&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports